<template>
  <v-dialog v-if="dialog" v-model="dialog" :max-width="width" persistent>
    <SDialog
      title="Affectation des capteurs"
      :icon="mainIcon"
      :loading="loading"
      @onClose="closeDialog"
    >
      <template v-slot:content-dialog>
        <form @submit.prevent="assignSensors()" class="form-login">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                label="Capteurs"
                prepend-icon="fa-microchip"
                color="primaryColor"
                item-color="primaryColor"
                item-text="macAddress"
                item-value="macAddress"
                v-model="userSensors"
                :items="sensors"
                multiple
                outlined
                chips
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </form>
      </template>
      <template v-slot:action-dialog>
        <SButton :loading="loading" @click="assignSensors()" raised success> Modifier </SButton>
        <SButton raised error @click="closeDialog" color="error">
          Annuler
        </SButton>
      </template>
    </SDialog>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserSensorsDialog",
  props: {
    oldSensors: {
      type: Array,
    },
    user: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: "60%",
    },
    mainIcon: {
      type: String,
    },
  },
  data: () => ({
    loading: false,
    sensors: [],
    userSensors: [],
  }),
  methods: {
    async assignSensors() {
      try {
        this.loading = true;
        await this.assignSensorsToUser({
          sensors: this.userSensors,
          user: this.user.uid,
        });
        this.loading = false;
      } catch ({ success, error }) {
        this.$emit("onErrors", { success, message: error });
        this.loading = false;
      }
    },
    closeDialog() {
      return this.$emit("closeDialog");
    },
    ...mapActions({
      retrieveSensors: "sensors/retrieveSensors",
      assignSensorsToUser: "sensors/assignSensorsToUser",
    }),
  },
  computed: {
    ...mapGetters({
      getSensors: "sensors/getSensors",
    }),
  },
  async created() {
    try {
      if (this.getSensors.length == 0) {
        await this.retrieveSensors();
      }
      this.userSensors = this.oldSensors.map((sensor) => sensor.macAddress);
      this.sensors = this.getSensors.filter(
        (sensor) => !sensor.owner || sensor.owner == this.$route.params.userId
      );
    } catch ({ success, error }) {
      this.$emit("onErrors", { success, message: error });
    }
  },
};
</script>

<style></style>
